// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1YPMe","title":"styles_title__2vZia"};